import constructNodeFromString from './constructNodeFromString'

export default function html (strings: TemplateStringsArray, ...keys: Array<string>) {
    let result = ''
    for (let i = 0; i < strings.length; i++) {
        result += strings[i] + (keys[i] || '')
    }

    return constructNodeFromString(result)
}
